// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__3GR_w","errors":"Errors_errors__2rUNF"};